import React from "react";
import { Tooltip as AntdTooltip } from "antd";

const Tooltip = ({ content, children }) => {
  if (!content) return <>{children}</>;
  return <AntdTooltip title={content}>{children}</AntdTooltip>;
};

export default Tooltip;
